import { useEffect, useState } from "react";
import { isUnauthorizedApiError } from "./api";
import type { PodcastPreferencesEnvelope } from "./types";

interface RememberedPodcastPreferences {
  userId: string;
  envelope: PodcastPreferencesEnvelope;
}

export function useSessionPodcastPreferences(
  userId: string | undefined,
  latest: PodcastPreferencesEnvelope | undefined,
  invalidated = false,
): PodcastPreferencesEnvelope | undefined {
  const [remembered, setRemembered] = useState<RememberedPodcastPreferences | null>(null);

  useEffect(() => {
    setRemembered((current) => {
      if (!userId || invalidated) return null;
      if (latest) return { userId, envelope: latest };
      return current?.userId === userId ? current : null;
    });
  }, [invalidated, latest, userId]);

  if (invalidated) return undefined;
  if (latest) return latest;
  return remembered && remembered.userId === userId ? remembered.envelope : undefined;
}

export async function clearSessionAfterPodcastAuthFailure(
  error: unknown,
  clearSession: () => void | Promise<unknown>,
): Promise<boolean> {
  if (!isUnauthorizedApiError(error)) return false;
  await clearSession();
  return true;
}
